import React from "react";
import {
  Box,
  Typography,
} from "@mui/material";
import { ANTooltip } from "@answersnow/pkg-theme";


interface CustomerLabelProps {
  label: string;
  value: string;
}

export const CustomerLabel: React.FC<CustomerLabelProps> = ({ label,value }) => {
  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", pb: 3, gap: 8 }}>
      <Typography variant="body2" color="textSecondary" sx={{ textWrap: "nowrap" }}>
        {label}
      </Typography>
      <ANTooltip component={Typography} variant="subtitle2">
        {value}
      </ANTooltip>
    </Box>
  );
};
